<div class="pageheader">
    <div class="page-title">
        <h1>Scheduler Tasks</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Scheduler tasks log'">
                <app-change-log-link-entity type="SchedulerTask"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<div class="btn-toolbar">
    <div class="btn-group">
        <button type="button" class="btn btn-primary btn-sm"
            *bizPermissionRequired="'Scheduler_Action_Scheduling_Edit'"
            [disabled]="selectedSchedulerTasks.length !== 1" (click)="onLogClicked($event)">Show log</button>
    </div>
</div>

<dx-data-grid biz-grid
              [dataSource]='schedulerTaskPresentations'
              [selection]='{ mode: "single" }'
              [bizSetPager]="false"
              (onToolbarPreparing)="onToolbarPreparing($event)"
              (onSelectionChanged)="onSelectionChanged($event)"
              (onEditingStart)="onEditingStart($event)"
              (onRowRemoving)="onRowRemoving($event)"
              (onRowDblClick)="onRowDblClick($event)">

    <dxo-editing mode="row"
                 [allowAdding]="allowAdding"
                 [allowUpdating]="allowUpdatingRow"
                 [allowDeleting]="allowDeletingRow">
        <dxo-texts editRow="Details"></dxo-texts>
    </dxo-editing>
    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxi-column dataField="SchedulerTask.Name" caption="Name" dataType="string" sortOrder="asc"></dxi-column>
    <dxi-column dataField="SchedulerTask.Description" caption="Description" dataType="string"></dxi-column>
    <dxi-column dataField="ScheduledItem.Enabled" caption="Enabled" dataType="boolean"></dxi-column>
    <dxi-column dataField="SchedulerTaskHandler.Name" caption="Scheduler task handler" dataType="string"></dxi-column>
    <dxi-column dataField="SchedulerTask.IsSystem" caption="Is System" dataType="boolean"></dxi-column>

    <dxi-column biz-grid-user dataField="SchedulerTask.CreatedBy" caption="Created By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(schedulerTasks, 'CreatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="SchedulerTask.CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
    <dxi-column biz-grid-user dataField="SchedulerTask.UpdatedBy" caption="Modified By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(schedulerTasks, 'UpdatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="SchedulerTask.UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

    <dxi-column type="buttons">
        <dxi-button name="edit"></dxi-button>
        <dxi-button name="delete"></dxi-button>
        <dxi-button text="Show Log"
                    template="logTemplate"
                    [visible]="allowShowLog">
        </dxi-button>
    </dxi-column>

    <ng-container *dxTemplate="let cell of 'logTemplate'">
        <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="SchedulerTask" [id]="cell.data.SchedulerTask.Id"></app-change-log-link-entity>
        </app-change-log-link>
    </ng-container>
</dx-data-grid>
